<script setup lang="ts">
import ActionButton from '@/components/Elements/Buttons/ActionButton.vue'
import AlertBox from '@/components/Elements/Alerts/AlertBox.vue'
import TutorialFrame from '@/components/Interface/Modal/Modals/Tutorial/TutorialFrame.vue'
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import GenericIcon from '@/components/Elements/Images/Icons/GenericIcon.vue'
import { handleNext } from '../tutorialSteps'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const route = useRoute()
const router = useRouter()

const handleNextStep = async () => {
  await handleNext('tutorial_pick_technology')
}

const isOnResearchSection = computed(() => {
  return route.path.startsWith('/research')
})

const goToResearch = () => {
  router.push('/research')
}

</script>

<template>
  <TutorialFrame
    video-url="https://cdn.ferion.com/videos/advisors/temperate/science.webm"
  >
    <template #text>
      <p class="pb-2">
        {{ t('tutorial.research.pickTechnology.intro') }}
      </p>
      <p class="pb-2">
        <i18n-t keypath="tutorial.research.pickTechnology.techCardInfo" tag="span">
          <template #icon><GenericIcon type="science" /></template>
        </i18n-t>
      </p>
      <p class="pb-2">
        {{ t('tutorial.research.pickTechnology.legend') }}
      </p>
    </template>

    <template #alerts>
      <AlertBox type="info">
        {{ t('tutorial.research.pickTechnology.selectFirst') }}
      </AlertBox>
    </template>

    <template #buttons>
      <ActionButton v-if="!isOnResearchSection" @click="goToResearch" class="mr-2">
        {{ t('tutorial.research.pickTechnology.goToResearch') }}
      </ActionButton>
      <ActionButton @click="handleNextStep">
        {{ t('tutorial.research.pickTechnology.done') }}
      </ActionButton>
    </template>
  </TutorialFrame>
</template>

<style scoped lang="scss"></style>